<template>
  <div class="content-wrapper">
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  props: [
  ],
  methods: {
  },
  async mounted () {
    // 洗車TOPへ遷移
    this.$router.push({
      name: 'V2Top',
      query: {
        tsid: this.$route.query.tsid,
        otoken: this.$route.query.otoken,
        popinfoid: this.$route.query.popinfoid,
        authid: this.$route.query.authid,
        ss_code: this.$route.query.ss_code,
        x_cls_app_version: this.$route.query.x_cls_app_version,
        x_cls_os: this.$route.query.x_cls_os,
        x_cls_os_version: this.$route.query.x_cls_os_version,
        dpi: this.$route.query.dpi,
        device_pixel_ratio: this.$route.query.device_pixel_ratio
      }
    })
  }
}
</script>
